
import { ChangeDetectionStrategy, Component, input, InputSignal, model, ModelSignal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { MatChipListbox, MatChipOption, MatChipSelectionChange } from '@angular/material/chips';
import { map } from 'rxjs';
import { FilterChipModel } from '@libs/common/models';

@Component({
  selector: 'ui-filter-chips',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatChipListbox, MatChipOption],
  templateUrl: './filter-chips.component.html',
  styleUrl: './filter-chips.component.scss',
})
export class FilterChipsComponent {
  public filterChips: InputSignal<FilterChipModel[]> = input.required();
  public selected: ModelSignal<FilterChipModel[]> = model([] as FilterChipModel[]);

  public constructor() {
    toObservable(this.filterChips).pipe(
      takeUntilDestroyed(),
      map(filterChips => {
        return this.selected()
          .map(selectedChip => filterChips.find(filterChip => filterChip.id === selectedChip.id))
          .filter((chip): chip is FilterChipModel => Boolean(chip));
      }),
    ).subscribe(
      chips => void this.selected.set(chips),
    );
  }

  public selectionChanged(event: MatChipSelectionChange, chip: FilterChipModel): void {
    let selectedChips: FilterChipModel[] = this.selected();

    if (event.selected) {
      if (!selectedChips.find(selectedChip => selectedChip.id === chip.id)) {
        selectedChips.push(chip);
      }
    } else {
      selectedChips = selectedChips.filter((selectedChip) => selectedChip.id !== chip.id);
    }

    this.selected.set([...selectedChips]);
  }
}
